import clientSide from '~/helpers/clientSide';
import { Decisions } from '~/types/providers';

export interface CheckVrcExperiencedEnabled {
  vrcExperienceEnabled: boolean;
  vrcExperienceModalEnabled: boolean;
  vrcExperienceYTTV: {
    enabled: boolean;
    value: number;
    showAllPromoBanner: boolean;
  };
  vrcExperienceExitIntentEnabled: boolean;
  timeoutDuration: number;
  vrcExperienceModalPlanSpeed?: string;
  vrcExperienceDelayPlanCardBannerEnabled: boolean;
}

const checkVrcExperiencedEnabled = (): CheckVrcExperiencedEnabled => {
  let vrcExperienceEnabled = false;
  let vrcExperienceModalEnabled = false;
  const vrcExperienceYTTV = {
    enabled: false,
    value: 50,
    showAllPromoBanner: true,
  };
  let vrcExperienceExitIntentEnabled = false;
  let timeoutDuration = 3000;
  let vrcExperienceModalPlanSpeed = '1000';
  let vrcExperienceDelayPlanCardBannerEnabled = false;

  if (clientSide) {
    window?.cohesion('preamp:decisionsReceived', function (decision: Decisions) {
      const placement = decision.placements.find(
        (placement) =>
          placement.placementName === 'plan-package-page-config' ||
          placement?.placementName === 'plan-package-redesign-page-config'
      ) as {
        metadata?: {
          vrcExperienceEnabled?: string;
          vrcExperience?: {
            vrcExperienceModalEnabled?: string;
            vrcExperienceDelayPlanCardBannerEnabled?: string;
            vrcExperienceExitIntentEnabled?: string;
            vrcExperienceModalDuration?: number;
            vrcExperienceYTTV?: {
              enabled: string;
              value: string;
              showAllPromoBanner?: string;
            };
            vrcExperienceModalPlanSpeed?: string;
          };
        };
      };

      vrcExperienceEnabled = placement?.metadata?.vrcExperienceEnabled === 'true';
      vrcExperienceModalEnabled = placement?.metadata?.vrcExperience?.vrcExperienceModalEnabled === 'true';
      vrcExperienceExitIntentEnabled = placement?.metadata?.vrcExperience?.vrcExperienceExitIntentEnabled === 'true';
      vrcExperienceModalPlanSpeed = placement?.metadata?.vrcExperience?.vrcExperienceModalPlanSpeed || '1000';
      timeoutDuration = placement?.metadata?.vrcExperience?.vrcExperienceModalDuration || 30000;
      vrcExperienceDelayPlanCardBannerEnabled =
        placement?.metadata?.vrcExperience?.vrcExperienceDelayPlanCardBannerEnabled === 'true';

      vrcExperienceYTTV.enabled = placement?.metadata?.vrcExperience?.vrcExperienceYTTV?.enabled === 'true';
      vrcExperienceYTTV.value = Number(placement?.metadata?.vrcExperience?.vrcExperienceYTTV?.value);
      vrcExperienceYTTV.showAllPromoBanner =
        placement?.metadata?.vrcExperience?.vrcExperienceYTTV?.showAllPromoBanner === 'true';
    });
  }

  return {
    vrcExperienceEnabled,
    vrcExperienceModalEnabled,
    vrcExperienceYTTV,
    vrcExperienceExitIntentEnabled,
    vrcExperienceModalPlanSpeed,
    timeoutDuration,
    vrcExperienceDelayPlanCardBannerEnabled,
  };
};

export default checkVrcExperiencedEnabled;
